export default "__VITE_ASSET__8f20da03__"